import { render } from "./categoryListSection.vue?vue&type=template&id=1a5c45a4&scoped=true"
import script from "./categoryListSection.vue?vue&type=script&lang=js"
export * from "./categoryListSection.vue?vue&type=script&lang=js"

import "./categoryListSection.vue?vue&type=style&index=0&id=1a5c45a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5c45a4"]])

export default __exports__